import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  submitLoading: false,
  err: null,
  initialValues: {},
  qcDataResponse: {},
  ppsr: {
    enableGenerateButton: false,
    search: {
      loading: false,
      error: false,
      columns: [],
      dataSource: [],
      total: 0,
      pageSize: 5
    },
    generate: {
      loading: false,
      error: false
    },
    statusCheck: {
      loading: false,
      error: false,
      data: null
    }
  }
};

const getVehicleDataStart = (state) => ({
  ...state,
  loading: true,
  initialValues: {},
  qcDataResponse: {}
});

const getVehicleDataFail = (state) => ({
  ...state,
  loading: false,
  initialValues: {},
  qcDataResponse: {}
});

const getVehicleDataSuccess = (state, action) => {
  const { appointmentId, qc = {}, vehicleDetails } = action.data;
  const isQCDataPresent = Object.keys(qc).length > 0;

  let initialValues = {
    appointmentId,
    vin: vehicleDetails?.vin
  };

  if (isQCDataPresent) {
    const { loanOnVehicle, qcStatus, stolenVehicle, writtenOffVehicle, ppsr, isDefenceCar } = qc;

    initialValues = {
      ...initialValues,
      loanOnVehicle,
      qcStatus,
      stolenVehicle,
      writtenOffVehicle,
      ppsr: [ppsr],
      isDefenceCar
    };
  }

  return {
    ...state,
    loading: false,
    qcDataResponse: {
      ...action.data
    },
    initialValues
  };
};

const submitFormStart = (state) => ({
  ...state,
  submitLoading: true
});

const submitFormSuccess = () => initialState;

const submitFormFail = (state, action) => ({
  ...state,
  submitLoading: false,
  err: action.err.status
});

const resetFormData = () => initialState;

const searchPpsrRequest = (state) => ({
  ...state,
  ppsr: {
    ...state.ppsr,
    search: {
      ...state.ppsr.search,
      loading: true,
      error: false
    }
  }
});

const searchPpsrSuccess = (state, action) => ({
  ...state,
  ppsr: {
    ...state.ppsr,
    enableGenerateButton: action.data?.enableGenerateButton,
    search: {
      ...state.ppsr.search,
      loading: false,
      error: false,
      columns: action.data?.columns || [],
      dataSource: action.data?.dataSource || [],
      total: action.data?.total || 0,
      pageSize: action.data?.pageSize || state.search.pageSize
    }
  }
});

const searchPpsrFailure = (state) => ({
  ...state,
  ppsr: {
    ...state.ppsr,
    search: {
      ...state.ppsr.search,
      loading: false,
      error: true,
      dataSource: []
    }
  }
});

/* ---------------- GENERATE PPSR ---------------- */

const generatePpsrRequest = (state) => ({
  ...state,
  ppsr: {
    ...state.ppsr,
    generate: {
      ...state.ppsr.generate,
      loading: true,
      error: false
    }
  }
});

const generatePpsrSuccess = (state) => ({
  ...state,
  ppsr: {
    ...state.ppsr,
    generate: {
      ...state.ppsr.generate,
      loading: false,
      error: false
    }
  }
});

const generatePpsrFailure = (state) => ({
  ...state,
  ppsr: {
    ...state.ppsr,
    generate: {
      ...state.ppsr.generate,
      loading: false,
      error: true
    }
  }
});

const checkPpsrStatusRequest = (state) => ({
  ...state,
  ppsr: {
    ...state.ppsr,
    statusCheck: {
      loading: true,
      error: false,
      data: null
    }
  }
});

const checkPpsrStatusSuccess = (state, action) => ({
  ...state,
  ppsr: {
    ...state.ppsr,
    enableGenerateButton: action.data?.enableGenerateButton,
    statusCheck: {
      loading: false,
      error: false,
      data: action.data
    }
  }
});

const checkPpsrStatusFailure = (state) => ({
  ...state,
  ppsr: {
    ...state.ppsr,
    statusCheck: {
      loading: false,
      error: true,
      data: null
    }
  }
});

const resetPpsrStatusCheck = (state) => ({
  ...state,
  ppsr: {
    ...state.ppsr,
    statusCheck: {
      loading: false,
      error: false,
      data: null
    }
  }
});

const qcFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_QC_DATA_START:
      return getVehicleDataStart(state, action);

    case actionTypes.GET_QC_DATA_SUCCESS:
      return getVehicleDataSuccess(state, action);

    case actionTypes.GET_QC_DATA_FAIL:
      return getVehicleDataFail(state, action);

    case actionTypes.SUBMIT_QC_START:
      return submitFormStart(state, action);

    case actionTypes.SUBMIT_QC_SUCCESS:
      return submitFormSuccess(state, action);

    case actionTypes.SUBMIT_QC_FAIL:
      return submitFormFail(state, action);

    case actionTypes.RESET_FORM_DATA:
      return resetFormData(state, action);

    case actionTypes.SEARCH_PPSR_START:
      return searchPpsrRequest(state);

    case actionTypes.SEARCH_PPSR_SUCCESS:
      return searchPpsrSuccess(state, action);

    case actionTypes.SEARCH_PPSR_FAIL:
      return searchPpsrFailure(state);

    case actionTypes.GENERATE_PPSR_START:
      return generatePpsrRequest(state);

    case actionTypes.GENERATE_PPSR_SUCCESS:
      return generatePpsrSuccess(state);

    case actionTypes.GENERATE_PPSR_FAIL:
      return generatePpsrFailure(state);

    case actionTypes.CHECK_PPSR_STATUS_START:
      return checkPpsrStatusRequest(state);

    case actionTypes.CHECK_PPSR_STATUS_SUCCESS:
      return checkPpsrStatusSuccess(state, action);

    case actionTypes.CHECK_PPSR_STATUS_FAIL:
      return checkPpsrStatusFailure(state);

    case actionTypes.RESET_PPSR_STATUS_CHECK:
      return resetPpsrStatusCheck(state);

    default:
      return state;
  }
};

export default qcFormReducer;
